import React from "react";
import { Dropdown } from 'react-bootstrap';
import './common.css'
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);

    const addClass = () => {
        document.getElementById("togglesidebar").classList.add('active_sidebar')
    }

    const removeClass = () => {
        document.getElementById("togglesidebar").classList.remove("active_sidebar");
    };

    return (
        <header className="d-flex align-items-center justify-content-between px-3 py-2 shadow-sm bg-white border-bottom">
            {/* Sidebar Toggle Button (for small screens only) */}
            <div className="sidebar_overlay" onClick={removeClass}></div>
            <button
                className="btn sidebar_btn d-inline-flex align-items-center justify-content-center d-xl-none"
                onClick={addClass}
            >
                <img
                    src={require('../assets/images/dashboard.svg').default}
                    alt="dashboard"
                    style={{ width: '20px', height: '20px' }}
                />
            </button>

            {/* Spacer div to push dropdown to right */}
            <div className="ms-auto">
                <Dropdown className="position-relative">
                    <Dropdown.Toggle
                        variant="light"
                        id="dropdown-basic"
                        className="border-0 d-flex align-items-center gap-2"
                    >
                        <i
                            className="fa fa-user rounded-circle d-flex justify-content-center align-items-center bg-secondary text-white"
                            style={{ width: '32px', height: '32px' }}
                        ></i>
                        <span className="fw-semibold text-dark">{user?.name}</span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-menu-end">
                        <Dropdown.Item onClick={() => navigate('/changepassword')}>
                            <i className="fa fa-pencil me-2 text-muted"></i> Change Password
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </header>
    )
}
export default Header;